export class Unit {
  id: number
  name: string
  description: string
  manufacturer: string
  model: string
  application: string
  category: string
  size: string
  sizeUnit: string

  constructor (id:number, name:string, description:string, manufacturer:string, model:string, application:string, category:string, size:string, sizeUnit:string) {
    this.id = id
    this.name = name
    this.description = description
    this.manufacturer = manufacturer
    this.model = model
    this.application = application
    this.category = category
    this.size = size
    this.sizeUnit = sizeUnit
  }
}
